var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Row',{staticClass:"u-padding__vertical--2",attrs:{"verticalCenter":""}},[_c('Col',{attrs:{"xs":10}},[_vm._t("left")],2),_c('Col',{attrs:{"xs":2,"right":""}},[_vm._t("right")],2)],1),_c('Divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }